import { $generateHtmlFromNodes } from '@lexical/html';
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { BLUR_COMMAND, COMMAND_PRIORITY_LOW } from 'lexical';
import { useEffect } from 'react';

export interface OnBlurPluginProps {
    initialHtml: string;
    onBlur: (
        // follow https://github.com/facebook/lexical/issues/1604 for a more reliable way to check if editor is dirty or not. Unresolved at the time of writing
        dirty: boolean,
    ) => void;
}

const OnBlurPlugin = ({ initialHtml, onBlur }: OnBlurPluginProps) => {
    const [editor] = useLexicalComposerContext();

    useEffect(() => {
        return editor.registerCommand(
            BLUR_COMMAND,
            () => {
                const currentHtml = $generateHtmlFromNodes(editor, null);
                onBlur(currentHtml !== initialHtml);
                return false;
            },
            COMMAND_PRIORITY_LOW,
        );
    }, [editor, initialHtml, onBlur]);

    return null;
};

export default OnBlurPlugin;
